'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _Sidebar = require('../Sidebar.styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultSidebar = function (_React$PureComponent) {
  _inherits(DefaultSidebar, _React$PureComponent);

  function DefaultSidebar() {
    _classCallCheck(this, DefaultSidebar);

    return _possibleConstructorReturn(this, (DefaultSidebar.__proto__ || Object.getPrototypeOf(DefaultSidebar)).apply(this, arguments));
  }

  _createClass(DefaultSidebar, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Sidebar.SidebarWrapper,
        null,
        _react2.default.createElement(
          _Sidebar.SidebarText,
          null,
          _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'core.accountDetails.sidebarDescription.default' })
        )
      );
    }
  }]);

  return DefaultSidebar;
}(_react2.default.PureComponent);

exports.default = DefaultSidebar;
module.exports = exports['default'];